const InfoTerkiniListItemCard = (data) => {
  return (
    <a href={`/info-terkini/${data?.data?.id}`}>
      <div
        className="bg-white px-4 py-3 rounded-lg mb-3"
        data-testid="success-list"
      >
        <div>
          {data?.data?.thumbnailUrl != '' && (
            <img
              src={data?.data?.thumbnailUrl}
              alt="image-thumbnail"
              className="object-cover h-24 w-full rounded"
            />
          )}

          <div className="py-3 text-base font-semibold">
            {data?.data?.title}
          </div>
          <div className="pb-3">
            <span
              className="text-xs px-2 py-1 rounded-lg font-semibold text-white"
              style={{
                backgroundColor: '#0B5FEF',
              }}
            >
              {data?.data?.category.name}
            </span>
          </div>
          <div className="text-sm">{data?.data?.publishDate}</div>
        </div>
      </div>
    </a>
  )
}

export default InfoTerkiniListItemCard
